var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasketDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF6767"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 13H22.75L22.4375 12.4375C22.3125 12.1875 22.0625 12 21.7812 12H18.1875C17.9062 12 17.6562 12.1875 17.5312 12.4375L17.25 13H13.5C13.2188 13 13 13.25 13 13.5V14.5C13 14.7812 13.2188 15 13.5 15H26.5C26.75 15 27 14.7812 27 14.5V13.5C27 13.25 26.75 13 26.5 13ZM14.6562 26.5938C14.6875 27.4062 15.3438 28 16.1562 28H23.8125C24.625 28 25.2812 27.4062 25.3125 26.5938L26 16H14L14.6562 26.5938Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketDelete);
export default __webpack_public_path__ + "static/media/basketDelete.564a57b8e628ea768cf3099f6da64004.svg";
export { ForwardRef as ReactComponent };